import {React, useEffect} from 'react';
import {connect} from 'react-redux';
import {Link, Redirect} from 'react-router-dom';
import {toast} from 'react-toastify';
import {loadUnreceivedTrans, resetUnreceivedTrans, resubmitTransaction} from "../../actions/Unreceived";
import {
  getTransactionMsg,
  UnreceivedTransaction,
  UnreceivedTransactionTable
} from "../../components/UnreceivedTransaction";
import {Reloading} from "../../components/Loader";
import {EmptyList} from "../../components/EmptyList";
import {formatMoney} from "../../utils/common";
import ToastProvider from "../../components/ToastProvider";

const UnreceivedTrans = ({dispatch, merchantInfo, accessToken, refreshToken, unreceivedTransData = {}, settingData = {}}) => {
  const {transactions, totalTrans, totalAmount, isLoading, isLoaded} = unreceivedTransData;
  const {isValidated, appId, branchId, storeId, cashierId, branchName, cashierName, storeName} = settingData;

  const appName = merchantInfo.apps ? merchantInfo.apps.find((app) => app.id === appId).name : '';

  useEffect(() => {
    console.log("Unreceived transaction", unreceivedTransData);
  }, [unreceivedTransData]);

  const reloadUnreceivedTrans = () => {
    dispatch(loadUnreceivedTrans(appId, branchId, storeId, cashierId, {
      access_token: accessToken,
      refresh_token: refreshToken
    }));
  };

  const notifyProcess = (promiseFunc, transaction) => {
    toast.promise(
      promiseFunc,
      {
        pending: {
          render() {
            return 'Giao dịch đang được ghi nhận, vui lòng chờ giây lát';
          },
        },
        success: {
          render() {
            setTimeout(() => reloadUnreceivedTrans(), 500);
            return <span>Đã ghi nhận thành công {getTransactionMsg(transaction.partner_transaction_time, transaction.amount)}</span>;
          },
          icon: <img src='/cashier/shop/static/assets/images/icon-success.svg' width='28'/>,
        },
        error: {
          render() {
            return 'Ghi nhận giao dịch thất bại, vui lòng thử lại sau';
          },
          icon: <img src='/cashier/shop/static/assets/images/icon-failed.svg' width='28'/>,
        },
      }
    );
  };

  const handleResubmitTrx = (transaction) => {
    // const resubmitPromise = new Promise((resolve, reject) => {
    return resubmitTransaction(transaction, {
      access_token: accessToken,
      refresh_token: refreshToken
    }).finally(() => {
      setTimeout(() => reloadUnreceivedTrans(), 500);
    });
    // });

    // notifyProcess(resubmitPromise, transaction);
  };

  useEffect(() => {
    if (isLoaded) {
      dispatch(resetUnreceivedTrans());
    }
  }, []);

  if (!isValidated) {
    return <Redirect to='/setting'/>;
  }

  return (
    <>
      <ToastProvider/>
      <div className='unreceived-trans-page container-fluid mt-4'>
        <div className='text-center'>
          <div className='text-sm-center'>
            <div className='page-title small-sm'>Danh sách chờ xác nhận</div>
          </div>

          <div className='left-icons'>
            <Link to='/home'>
              <img
                src='/cashier/shop/static/assets/images/icon-back.svg'
                width='28'
                alt=''
              />
            </Link>
          </div>
        </div>

        <div className='row mt-5'>
          <div className='col-md-6 col-sm-6 mb-4'>
            <div className='media'>
              <img
                className='mr-3'
                src='/cashier/shop/static/assets/images/logo-mc-default.svg'
                width='72'
                alt=''
              />
              <div className='media-body'>
                <div className='mc-name mb-1'>{appName.toUpperCase()}</div>
                <div className='txtGray fs-s'>
                  {branchName}
                  <br/>
                  {storeName + ' - ' + cashierName}
                </div>
              </div>
            </div>
          </div>
          <div className='col-md-6 col-sm-6 float-right'>
            <div className='row'>
              <div className='col-md-6'></div>
              <div className='col-md-6'>
                <div className='mb-4 text-center'>
                  <div className='fs-s'>TỔNG TIỀN GD ĐANG CHỜ XỬ LÝ</div>
                  <strong className='txtBlack fs-m'>
                    {formatMoney(totalAmount, 0, '') + ' VNĐ'}
                  </strong>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='row mt-2 mb-5'>
          <div className='col-md-4'></div>
          <div className='col-md-4 d-flex justify-content-center'>
            <button className='btn btn-success' onClick={() => reloadUnreceivedTrans()}>Tra cứu giao dịch</button>
          </div>
          <div className='col-md-4'></div>
        </div>
      </div>
      {isLoading ? <Reloading/> :
        totalTrans > 0 && transactions ?
          <>
            <UnreceivedTransactionTable>
              {
                transactions.map((trx, idx) =>
                  <UnreceivedTransaction transaction={trx} key={idx} onResubmit={handleResubmitTrx}/>)
              }
            </UnreceivedTransactionTable>
          </> :
          <EmptyList/>
      }
    </>
  );
};

const mapDispatchToProps = (state) => {
  return {
    merchantInfo: state.loginData.result,
    accessToken: state.loginData.token,
    refreshToken: state.loginData.refreshToken,
    unreceivedTransData: state.unreceivedTransData,
    settingData: state.settingData,
  }
}

export default connect(mapDispatchToProps)(UnreceivedTrans);
